import { createContext } from 'react';

export const inputAutocompleteContext = createContext<boolean>(false);
